module.exports = __webpack_public_path__ + "img/xf.ddf6f1e3.png";